import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'
import { encodeSHA256, encryptAES } from '../../apis/config/utils'
import {
  getCookieAuthUser,
  getCookieProfileUser
} from '../../../../auth/services/token-service'
import type { IProfileUser } from '../../../../interfaces/src'

const AUTH_KEY_SECRET = process.env.AUTH_KEY_SECRET

export function basicXRequestInterceptor(config: AxiosRequestConfig<any>) {
  const timestamp = Date.now()
  const token = encodeSHA256(timestamp, AUTH_KEY_SECRET as string)

  const cookieProfileUser = getCookieProfileUser()
  const cookieAuthUser = getCookieAuthUser()

  const binaryRole = cookieAuthUser?.binaryRoles

  const profileUser: IProfileUser = cookieProfileUser

  const xCustomAuth = {
    userId: profileUser?.userId,
    roles: binaryRole ? binaryRole : undefined,
    agencyId: profileUser?.agencyId ? profileUser?.agencyId : undefined
  }

  const encryptedXCustomAuth = encryptAES(
    xCustomAuth,
    AUTH_KEY_SECRET as string
  )

  config.headers = {
    timestamp: `${timestamp}`,
    Authorization: `${token}`,
    'X-Custom-Auth': `${encryptedXCustomAuth}`
  }

  return config as InternalAxiosRequestConfig
}
